// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"_k_vLB4J","img":"Pw0rgBSH","border":"wgcHl9nS","text":"MRpw3fUr","bold":"sb6OiC5Q"};